import { checkFeatureAuth } from '@/services';
import { env, ENV_kEYS } from '@/utils';
import { gtrSendEvents } from '@/micro-app';

const resolveCallbacks = {};
async function getAuthCache(nodeKey) {
  return new Promise((resolve) => {
    if (resolveCallbacks[nodeKey]) {
      resolveCallbacks[nodeKey].push(resolve);
    } else {
      resolveCallbacks[nodeKey] = [resolve];
      checkFeatureAuth({ nodeKey })
        .then((res) => {
          env.update(ENV_kEYS.featureAuth, { [nodeKey]: { isAuth: res } });
          resolveCallbacks[nodeKey].forEach((i) => {
            i(res);
          });
          delete resolveCallbacks[nodeKey];
        })
        .catch((e) => {
          console.warn(e);
          resolveCallbacks[nodeKey].forEach((i) => {
            i(false);
          });
          delete resolveCallbacks[nodeKey];
        });
    }
  });
}

export async function gtrAuth(nodeKey) {
  const feature_auth = env.get(ENV_kEYS.featureAuth);
  if (feature_auth && feature_auth[nodeKey]) {
    return feature_auth[nodeKey].isAuth;
  }
  try {
    return await getAuthCache(nodeKey);
  } catch (e) {
    console.warn(e);
    return undefined;
  }
}

export async function gtrAuths(authKeys) {
  if (!Array.isArray(authKeys)) return console.warn(`${authKeys}不是一个数组`);
  return Promise.all(
    authKeys.map(async (key) => {
      return gtrAuth(key);
    }),
  );
}
// 权限弹窗控制
export function gtrAuthNotify(data) {
  gtrSendEvents.GTR_LISTEN_EVENT_PERMISSION_NOTIFY(data);
}
